/**
 * Downloads a blob response as a file, taking the name from the content disposition when the server sends
 * one and falling back to the given name otherwise.
 * <p>
 * Shared by the admin exports: the same code used to live inline in every hook that downloads a spreadsheet.
 */
export const saveBlob = (data: any, headers: any, fallbackName: string) => {
	const disposition =
		headers?.['content-disposition'] ?? headers?.['Content-Disposition'];

	let filename = fallbackName;

	if (typeof disposition === 'string') {
		const match =
			disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i) ??
			disposition.match(/filename="?([^"]+)"?/i);

		if (match?.[1]) {
			filename = decodeURIComponent(match[1].trim().replace(/^"|"$|'/g, ''));
		}
	}

	const contentType =
		headers?.['content-type'] ??
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

	const url = window.URL.createObjectURL(new Blob([data], { type: contentType }));

	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = filename;
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();
	window.URL.revokeObjectURL(url);
};

/** Today as yyyy-mm-dd, for the fallback file names of the exports. */
export const today = () => new Date().toISOString().slice(0, 10);
